<template>
    <rkm-modal
        extra-large
        persistent
        ref="RkmModal"
        title="Agendamentos"
    >
        O paciente possui o(s) seguinte(s) agendamento(s):<br><br>

        <rkm-table
            :fields="fields"
            :items="itens"
            hide-filters
            hide-pagination
            sort-by="text"
        />

        <br>

        Deseja continuar?

        <template v-slot:footer>
            <rkm-button
                @click="close"
                color="primary"
            >
                Sim
            </rkm-button>

            <rkm-button @click="cancel">
                Não
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Mixins.
import {formats} from '@/mixins'

// Moment
import moment from 'moment'

export default {
    data() {
        return {
            fields: [
                {key: 'data', label: 'Data viagem', formatter: v => this.formatDate(v), sortable: true},
                {key: 'motivoDescricao', label: 'Motivo', sortable: true},
                {key: 'municipio', label: 'Município', sortable: true},
                {key: 'destino', label: 'Local consulta', sortable: true},
                {key: 'horario', label: 'Horário', sortable: true},
                {key: 'veiculoDescricao', label: 'Veículo', sortable: true},
                {key: 'jornadaDescricao', label: 'Jornada', sortable: true},
                {key: 'observacao', label: 'Observação'},
            ],
            itens: [],
            onCancel: null,
            others: {moment},
        }
    },
    methods: {
        open(itens, onCancel) {
            this.itens = itens.map(item => ({
                data: this.others.moment(item.data, 'DD/MM/YYYY').format('YYYY-MM-DD'),
                motivoDescricao: item.motivoDescricao,
                municipio: item.municipio,
                destino: item.destino,
                horario: item.horario,
                veiculoDescricao: item.veiculoDescricao,
                jornadaDescricao: item.jornadaDescricao,
                observacao: item.observacao,
            }))

            this.onCancel = onCancel

            this.$refs.RkmModal.show()
        },
        cancel() {
            this.onCancel()
            this.close()
        },
        close() {
            this.$refs.RkmModal.hide()
        }
    },
    mixins: [formats],
}
</script>